// extracted by css-extract-rspack-plugin
export default {"main":"Presenter__main--BmDMB"};